import { gql } from '@apollo/client'

export default gql(`
    mutation addOfferAttribute($input: [OfferAttributeInput] $project: String) {
        addOfferAttribute(
            input: $input
            project: $project
        ){
            id
        }
    }`
)
